import { useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { useAuthStore } from "@/stores/auth.store";

interface RequirePasswordChangeProps {
  children: React.ReactNode;
}

export function RequirePasswordChange({ children }: RequirePasswordChangeProps) {
  const navigate = useNavigate();
  const location = useLocation();
  const { user, isAuthenticated } = useAuthStore();

  useEffect(() => {
    // Se o usuario esta autenticado, e do tipo company, e precisa trocar senha
    if (
      isAuthenticated &&
      user?.type === "company" &&
      user?.mustChangePassword &&
      location.pathname !== "/change-password"
    ) {
      navigate("/change-password", { replace: true });
    }
  }, [isAuthenticated, user, location.pathname, navigate]);

  // Se precisa trocar senha, nao renderiza o conteudo protegido
  if (
    isAuthenticated &&
    user?.type === "company" &&
    user?.mustChangePassword &&
    location.pathname !== "/change-password"
  ) {
    return null;
  }

  return <>{children}</>;
}
